/** Keep commercial enquiries out of the residential assessment scheduler. */
export function commercialQuoteHref(pathname: string | null): string | null {
  const path = pathname?.replace(/\/+$/, '')
  if ([
    '/blog/solar-window-film-vs-blinds',
    '/blog/solar-film-low-e-double-pane-windows',
    '/blog/commercial-window-film-vlt-comparison',
    '/blog/clear-view-plus-ceramic-alloy-comparison',
    '/blog/commercial-window-film-energy-savings-model',
    '/blog/solar-window-film-winter-ontario',
    '/blog/restaurant-window-film-heat-glare-privacy',
    '/blog/retail-window-film-uv-fading-displays',
  ].includes(path ?? '')) return '/commercial/quote?service=solar'
  if (
    path === '/blog/commercial-window-film-quote-checklist' ||
    path === '/blog/commercial-window-film-installation-preparation' ||
    path === '/blog/commercial-window-film-sample-review' ||
    path === '/blog/industrial-window-film-staff-areas' ||
    path === '/blog/condominium-common-area-window-film' ||
    path === '/blog/multi-site-commercial-window-film-specification' ||
    path === '/blog/commercial-window-film-tenant-landlord-scope'
  ) return '/commercial/quote'
  if (path === '/blog/office-solar-window-film-heat-glare') return '/commercial/quote?service=solar'
  if (path === '/blog/privacy-window-film-at-night' || path === '/blog/white-frost-vs-dusted-crystal') return '/commercial/quote?service=privacy'
  if (
    path === '/blog/meeting-room-privacy-film-frosting' ||
    path === '/blog/office-privacy-film-coverage-layout'
  ) return '/commercial/quote?service=privacy'
  if (path === '/commercial' || path?.startsWith('/commercial/')) return '/commercial/quote'
  return null
}

/** Product pages welcome residential and commercial film enquiries alike. */
export function filmQuoteHref(pathname: string | null): string | null {
  const path = pathname?.replace(/\/+$/, '')
  if (path === '/products/solar-film') return '/quote?service=solar'
  if (path === '/products/privacy-film') return '/quote?service=privacy'
  return null
}
